import { BRAND_SIGNAL, SUN_PATH_D } from '../../brand/constants'

type XosaSunIconProps = {
  className?: string
  size?: number
  'aria-hidden'?: boolean
}

/**
 * Striped sun mark — same geometry as the header wordmark (GiStripedSun).
 */
const XosaSunIcon: React.FC<XosaSunIconProps> = ({
  className,
  size = 36,
  'aria-hidden': ariaHidden = true,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
    className={className}
    aria-hidden={ariaHidden}
    fill={BRAND_SIGNAL}
  >
    <path d={SUN_PATH_D} />
  </svg>
)

export default XosaSunIcon
